import { setupLayouts } from 'virtual:generated-layouts'
import { createWebHashHistory } from 'vue-router'
import { createRouter } from 'vue-router/auto'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'

import { createRouterGuard } from './guard'
import publicRoutes from './public-routes'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: () => import('@/pages/onboarding/goal-first.vue'),
      meta: { layout: false },
    },
    ...setupLayouts(routes),
    ...publicRoutes,
  ],

  scrollBehavior() {
    return { left: 0, top: 0, behavior: 'smooth' }
  },
})

// 异步初始化路由守卫
createRouterGuard(router)

export default router

if (import.meta.hot) {
  handleHotUpdate(router)
}
